module.exports = __webpack_public_path__ + "img/certificate_bg.e7d7e438.png";